//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HouseItem from '@/components/business/house_item'
import CommonImg from '@/components/views/common_img'
import Log from '@/common/user_log_mixins/log_1_3'
export default {
    mixins: [
        Log
    ],
    watch: {
        you_like (latest) {
            if (latest.primary_position || latest.secondary_position) {
                this.initLog_1_3({
                    dom_id: 'you_like_col_1',
                    ids: latest.primary_position || [],
                }, {
                    dom_id: 'you_like_col_3',
                    ids: latest.secondary_position || []
                })
            }
        }
    },
    methods: {},
    props: {
        you_like: {
            type: Object,
            default: () => ({})
        }
    },
    components: {
        HouseItem,
        CommonImg
    }
}
